import { render } from "./MainCardComp.vue?vue&type=template&id=e2a35194&scoped=true&ts=true"
import script from "./MainCardComp.vue?vue&type=script&lang=ts"
export * from "./MainCardComp.vue?vue&type=script&lang=ts"

import "./MainCardComp.vue?vue&type=style&index=0&id=e2a35194&lang=scss"
import "./MainCardComp.vue?vue&type=style&index=1&id=e2a35194&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2a35194"]])

export default __exports__